import React from 'react'
import './Recruitersec.css'
import img from '../../assets/others/11102041.png'


const Recruitersec = () => {
  return (
    <div class="recrutier-section ws-section pb-5">
        <div class="container text-center dark-background-2 radius-1">
            <div class="row collabs-logos">
                <div class="col-lg-7 text-left p-5 bg-o radius-1">
                    <h2 class="ws-section_heading text-white ">Our Employers</h2>
                    <p className='mb-5'>Throughout the years, Takshila has proven to be a force to reckon as a launching pad for individuals venturing into the VLSI industry. The uniqueness and quality of our training provided are evident in the high placement of our students in various companies.</p>
                    <img className='radius-1' src={img} alt=''/>
                </div>
                <div class="col-lg-5">
                    
                </div>
            </div>
         </div>
    </div>
  )
}

export default Recruitersec